import { usePiniaStore } from "@/stores/store";
import { getOrganisationSettings } from "@/apis/esendaV2/organisation";
import type { NavigationGuard } from "vue-router";

/**
 * Guard to call with the beforeEnter hook to check if a setting
 * exists in the active organisation settings and matches to passed value
 * (`true` by default)
 *
 * example: `settingsGuard("uses_bacs", true)`
 *
 * @param settingName key from the active organisation settings
 * @param expectedValue value to check which controls the route
 */
function settingsGuard(
    settingName: string,
    expectedValue: any = true,
): NavigationGuard {
    return async () => {
        const pStore = usePiniaStore();
        let settings = pStore.getSchoolSettings as Record<string, unknown>;
        const shortcode = pStore.getSchoolShortcodes[0];
        const hasSetting = () =>
            Object.prototype.hasOwnProperty.call(settings, settingName);
        if (!hasSetting() && shortcode) {
            const loadedSettings = await getOrganisationSettings(shortcode);
            if (pStore.getSchoolShortcodes[0] !== shortcode) {
                return "/unauthorised-access";
            }
            settings = loadedSettings ?? settings;
        }
        const routeEnabled =
            hasSetting() && settings[settingName] === expectedValue;

        return routeEnabled ? true : "/unauthorised-access";
    };
}

export default settingsGuard;
